module.exports = __webpack_public_path__ + "fabed2f9a81147a5270fdd54b8b67db9.svg";


//////////////////
// WEBPACK FOOTER
// ./static/badge/ios/FR.svg
// module id = 3156
// module chunks = 0